module.exports = __webpack_public_path__ + "img/Woveon_Hero.775b3454.jpg";